/* eslint-disable no-unused-vars */
import axios from 'axios';
import Utils from '../../redux/utils';
import { baseURL } from '../../config/constant';

const getHelpResponse = async (query) => {
  let data = JSON.stringify({ query });
  try {
    const response = await axios.post(
      'https://help.sadaynaal.com/answer/',
      data,
      {
        headers: {
          maxBodyLength: Infinity,
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Utils.getCurrentToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching help response:', error);
    throw error;
  }
};

const getHelpAudioResponse = async (audioBlob) => {
  try {
    if (!(audioBlob instanceof Blob)) {
      throw new Error('Invalid audio data. Please record again.');
    }
    const acceptedFormats = [
      'audio/mpeg',
      'audio/wav',
      'audio/ogg',
      'audio/aac',
      'audio/flac',
      'audio/webm',
      'audio/mp3',
    ];
    if (!acceptedFormats.includes(audioBlob.type)) {
      throw new Error(
        'Unsupported audio format. Please use MP3, WAV, OGG, AAC, FLAC, or WebM.'
      );
    }
    const formData = new FormData();
    formData.append('audio', audioBlob, 'recorded_audio.wav');
    const response = await axios.post(
      'https://help.sadaynaal.com/answer/audio',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${Utils.getCurrentToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching help response:', error);
    throw error;
  }
};

const HelpApi = {
  getHelpResponse,
  getHelpAudioResponse,
};

export default HelpApi;
